<template>
	<div>
		<div class="fr-fullscreen" v-if="spinnerLoadingState">
			<div class="spinner-border" role="status">
				<span class="sr-only">Caricamento...</span>
			</div>
		</div>
		<div class="alertMobile">
			<img style="width: 70%;" src="assets/fleerun-esm.png" />
			<h4>ATTENZIONE</h4>
			<p>Per visualizzare correttamente Fleerun devi ingrandire le dimensioni della finestra del tuo browser.</p>
		</div>
		<div id="app">
			<component :is="layout">
				<router-view></router-view>
			</component>
			<kendo-notification ref="popupNotification" @show="onShow" :auto-hide-after="hideAfter" :position-top="notificationPositionTop" :position-right="30"></kendo-notification>
		</div>
	</div>
</template>

<script>
const default_layout = "default";
import { bus } from "./main";
import { mapGetters } from "vuex";
import * as VueGoogleMaps from "vue2-google-maps";

export default {
	data: function() {
		return {
			routes: [],
			isClosedMenu: false,
			hideAfter: 7000,
			minTimeToHide: 7000,
			maxTimeToHide: 20000,
			notificationPositionTop: 25,
			notificationPadding: 15,
			spinnerLoadingState: false,

			spinnerLoadingTimeout: null
		};
	},
	beforeMount() {
		if (this.$store.getters.settings.maps.apiKey)
			VueGoogleMaps.loadGmapApi({
				key: this.$store.getters.settings.maps.apiKey,
				libraries: "places"
			});
	},
	created() {
		var self = this;
		bus.$on("responseNotification", this.showPopupNotification.bind(self));
		bus.$on("successNotification", this.showSuccessNotification.bind(self));
		bus.$on("show-spinner-loading", this.showSpinnerLoading.bind(self));
		bus.$on("hide-spinner-loading", this.hideSpinnerLoading.bind(self));
	},
	mounted() {
		var self = this;
		this.popupNotificationWidget = this.$refs.popupNotification.kendoWidget();
	},
	computed: {
		layout: function() {
			return (this.$route.meta.layout || default_layout) + "-layout";
		}
	},
	methods: {
		showSpinnerLoading() {
			var self = this;
			clearTimeout(self.spinnerLoadingTimeout);
			this.spinnerLoadingState = true;

			self.spinnerLoadingTimeout = setTimeout(() => {
				self.spinnerLoadingState = false;
			}, 60000);
		},
		hideSpinnerLoading() {
			clearTimeout(self.spinnerLoadingTimeout);
			this.spinnerLoadingState = false;
		},
		onShow(e) {
			if (e.sender.getNotifications().length > 0) {
				var element = e.element.parent(),
					top = element.position().top,
					eWidth = element.width(),
					eHeight = element.height(),
					wWidth = $(window).width(),
					wHeight = $(window).height(),
					left = wWidth - eWidth - 30,
					newTop;

				newTop = e.sender.getNotifications().length * this.notificationPositionTop + this.notificationPadding * e.sender.getNotifications().length;
				
				e.element.parent().css({ top: newTop, left: left, position: "fixed" });
			}
		},
		showSuccessNotification(msg) {
			var self = this;
			var hideAfter = this.getTimeToHide(msg);
			this.hideAfter = hideAfter;

			this.$nextTick(function() {
				self.popupNotificationWidget.success(msg);
			});
		},
		showPopupNotification(payload) {
			var self = this;
			var status = payload.status;

			if (payload.messages) {
				var messages = payload.messages;
				// if (status === "ko") {
				//     status = "error";
				// } else if (status === "warning") {
				//     status = "warning";
				// }
				// else if (status === "success") {
				// 	status = "success";
				// } else {
				//     status = "info";
				// }

				for (var i = 0; i < messages.length; i++) {
					var msg = messages[i];

					var showMessage = function(msgt) {
						var hideAfter = self.getTimeToHide(msgt.text);
						self.hideAfter = hideAfter;

						self.$nextTick(function() {
							self.popupNotificationWidget[msgt.type](msgt.text);
						});
					};

					showMessage(msg);
				}
			} else if (payload.errors) {
				var errors = payload.errors;

				try {
					for (var i = 0; i < Object.keys(errors).length; i++) {
						var prop = Object.keys(errors)[i];
						for (var j = 0; j < errors[prop].length; j++) {
							var msg = errors[prop][j];

							var showMessage = function(msgt) {
								var hideAfter = self.getTimeToHide(msgt);
								self.hideAfter = hideAfter;

								self.$nextTick(function() {
									self.popupNotificationWidget["error"](msgt);
								});
							};

							showMessage(msg);
						}
					}
				} catch (ex) {
					console.log("Errore nel mostrare la notifica");
					console.log(ex);
				}
			}
		},
		getTimeToHide(msg) {
			var timeBySplit = this.minTimeToHide;
			if (msg) {
				var splitMsg = msg.split(" ");

				if (splitMsg.length > 4) {
					timeBySplit = 4000;
					for (var i = 0; i < splitMsg.length; i++) {
						timeBySplit += 500;
					}

					if (timeBySplit > this.maxTimeToHide) timeBySplit = this.maxTimeToHide;
					if (timeBySplit < this.minTimeToHide) timeBySplit = this.minTimeToHide;
				}
			}

			return timeBySplit;
		},
		generalClick() {
			this.$root.$emit("bv::hide::tooltip");
		},
		openMenu() {
			this.isClosedMenu = false;
		},
		closeMenu() {
			this.isClosedMenu = true;
		}
	}
};
</script>
